import { IService } from '../interface/IService';
export abstract class Service implements IService {}
